var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistoryIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 13C0 5.8203 5.8203 0 13 0C20.1797 0 26 5.8203 26 13C26 19.6051 21.0753 25.0577 14.6968 25.8901C13.8753 25.9973 13.1225 25.4183 13.0153 24.5968C12.9081 23.7754 13.4871 23.0225 14.3086 22.9153C19.2125 22.2753 23 18.0788 23 13C23 7.47715 18.5228 3 13 3C7.47715 3 3 7.47715 3 13C3 15.7967 4.14688 18.3252 6 20.1415V17.5C6 16.6716 6.67157 16 7.5 16C8.32843 16 9 16.6716 9 17.5V23.5C9 24.3284 8.32843 25 7.5 25H1.5C0.671573 25 0 24.3284 0 23.5C0 22.6716 0.671573 22 1.5 22H3.61927C1.3792 19.6654 0 16.4936 0 13ZM13 5.5C13.8284 5.5 14.5 6.17157 14.5 7V12.25L16.5667 13.8C17.2294 14.2971 17.3637 15.2373 16.8667 15.9C16.3696 16.5627 15.4294 16.6971 14.7667 16.2L12.1 14.2C11.7223 13.9167 11.5 13.4721 11.5 13V7C11.5 6.17157 12.1716 5.5 13 5.5Z",
    fill: "#525252"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryIcon);
export default __webpack_public_path__ + "static/media/historyIcon.5a18fc0c155d8c4a90f4033acd96f956.svg";
export { ForwardRef as ReactComponent };